import { instance, authInstance } from '../api/api';
import { IAuthResponse, IServerUser, Role } from '../types/type';
import { toApiError } from '../utils/apiError';

interface ICreateUser {
  login: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  role: Role;
  status: string | boolean;
}

interface ILoginUser {
  login: string;
  password: string;
}

export const AuthService = {
  async registration(userData: ICreateUser) {
    try {
      const response = await instance.post<ICreateUser>('profiles', userData);
      return response.data;
    } catch (error: any) {
      // errors[0].message из {"errors":[…]}, иначе старое поле message
      throw toApiError(error, 'Ошибка регистрации');
    }
  },
  async login(userData: ILoginUser) {
    try {
      const { data } = await authInstance.post<IAuthResponse>('auth/login', userData);
      return data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to login');
    }
  },
  async refreshToken(refreshToken: string) {
    try {
      const { data } = await authInstance.post<IAuthResponse>('auth/refresh', { refreshToken: refreshToken });
      return data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to refresh token');
    }
  },
  async getProfile(): Promise<IServerUser | undefined> {
    try {
      const { data } = await instance.get<IServerUser>('/profile');
      return data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch profile');
    }
  },
};
